import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { ExchangeMembersReportData } from "../types";

export const useExchangeMembersReportData = () => {
  const data = useSelector<StoreType, ExchangeMembersReportData[] | undefined>(
    (s) => s.data.reports.exchangeMember.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
